var $184b7c001c9aa90c$exports = {};
$184b7c001c9aa90c$exports = {
    "endTime": `L\xf5puaeg`,
    "startTime": `Algusaeg`,
    "time": `Aeg`
};


export {$184b7c001c9aa90c$exports as default};
//# sourceMappingURL=et-EE.mjs.map
